<template>
  <div id="app">
      <customHeader/>
      <inicio/>
      <aboutUs/>
      <quote/>
      <services/>
      <projects/>
      <contact/>
  </div>
</template>

<script>
import inicio from './components/inicio'
import aboutUs from './components/aboutUs'
import quote from './components/quote'
import services from './components/services'
import contact from './components/contact'
import customHeader from './components/menu'
import projects from './components/projects'


export default {
  name: 'app',
  components: {
    inicio,
    aboutUs,
    quote,
    services,
    contact,
    customHeader,
    projects
  },
  
}
</script>

<style>
#app {
  font-family: 'Montserrat', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  overflow: hidden;
}


</style>



// WEBPACK FOOTER //
// src/App.vue